import { render } from "./motion-content-input.vue?vue&type=template&id=9b47f27c"
import script from "./motion-content-input.vue?vue&type=script&lang=js"
export * from "./motion-content-input.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__